var _path, _g, _path2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCod(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "p7yaxwevda",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 12,
    height: 6
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.733.184-2.17 5.05h-2.17c-.36 0-.711.027-1.053.1l.9-2.161.036-.081.054-.145c.027-.063.045-.117.072-.162C5.447.364 6.617-.393 8.732.184zM14.845 5.477l-.018-.009a6.02 6.02 0 0 0-1.647-.234H7.544L9.57.525l.027-.063c.126.045.26.108.396.153l1.99.838c1.107.459 1.88.936 2.358 1.512.081.108.153.207.225.324.081.126.144.252.18.387.036.081.063.153.081.234.135.46.144.982.018 1.567z",
    fill: "#292D32"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#p7yaxwevda)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#605nps9azb)",
    d: "M2.25 0h18v18h-18z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "d62jikj9gc",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 18,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.45 6.764a4.553 4.553 0 0 0-1.27-.18H4.393a4.3 4.3 0 0 0-1.728.351A4.406 4.406 0 0 0 0 10.977v1.756c0 .216.018.423.045.64.198 2.862 1.729 4.393 4.591 4.582.208.027.415.045.64.045h7.022c3.33 0 5.086-1.585 5.257-4.736.01-.171.018-.351.018-.531v-1.756a4.411 4.411 0 0 0-3.123-4.213zm-3.412 6.51H6.535a.68.68 0 0 1-.675-.676.68.68 0 0 1 .675-.675h4.502a.68.68 0 0 1 .675.675.68.68 0 0 1-.675.675z",
    fill: "#292D32"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d62jikj9gc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#gqq7mhtkmd)",
    d: "M-1.125 5.625H18V18H-1.125z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "605nps9azb",
    x1: 2.25,
    y1: 0,
    x2: 2.25,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gqq7mhtkmd",
    x1: -1.125,
    y1: 5.625,
    x2: -1.125,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCod);
export default __webpack_public_path__ + "static/media/ic-cod.da17826c6c9ba2dedffef19b8b716228.svg";
export { ForwardRef as ReactComponent };